import { useAlertStore } from '../utils/alert';
import style from '../styles/FeedbackModal.module.css';
import { useEffect } from 'react';

/**
 * A Dynamic feedback modal that changes content/layout based on global state
 * Reads relevant state from utils/alert.ts
 * @returns callable FeedbackModal component
 */
export function FeedbackModal() {
  // setup use references
  const alert = useAlertStore((state) => state.alert);
  const closeAlert = useAlertStore((state) => state.closeAlert);

  // Detect conditional rendering
  useEffect(() => {
    if (alert) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [alert]);

  // Clear display if feedback is empty/resolved
  if (!alert) return null;

  // Standard display
  return (
    <div className={style.dimmer}>
      <div className={`${style.modal} ${alert ? style.open : ''}`}>
        {/* Alert title */}
        <h2> {alert.header} </h2>

        {/* Alert body text */}
        <p> {alert.body} </p>

        {/* Confirmation button */}
        <button onClick={closeAlert}> {alert.button} </button>
      </div>
    </div>
  );
}
